import { lazy, Suspense, useEffect, useSyncExternalStore } from 'react'
import { useSelector } from 'react-redux'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { AuthRoute } from 'react-router-auth'
// component 묶음(index.js)은 모든 화면을 불러와서, 첫 화면에 필요한 것만 경로로 직접 가져온다 (라우트별 lazy 분리가 먹히게)
import LangComponent from 'component/Lang/Component'
import Alert from 'ccomponent/Alert'
import AlertSnackbar from 'ccomponent/AlertSnackbar'
import Confirm from 'ccomponent/Confirm'
import Popover from 'ccomponent/Popover'
import Loading from 'ccomponent/Loading'
import ErrorPage from 'ccomponent/ErrorPage'
import BackDrop from 'ccomponent/BackDrop'
import AnswerErrorPage from 'ccomponent/AnswerErrorPage'
import IframeDialog from 'ccomponent/IframeDialog'
import ModuleTipPopup from 'ccomponent/ModuleTipPopup'
import Dialog from 'ccomponent/Dialog'
import { SessionGuard, AuthGate } from 'component/Session/SessionGuard'
import { getHasMe, subscribeMe, hasLoginContext } from 'ts-utils/session'
import * as googleConfig from 'config/google.json'
import TagManager from 'react-gtm-module'

// 결과 파일 다운로드 (엑셀·압축 라이브러리가 커서 해당 주소로 들어올 때만 불러온다)
const FileDownloadContainer = lazy(() => import('container/Survey/Create/NewAnalysis/Rows/FileDownload'))
const MyResponseFileDowoloadLocaleContainer = lazy(() => import('container/Survey/Create/NewAnalysis/Rows/MyResponseFileDowoloadLocale'))

const ObstacleContainer = lazy(() => import('container/Obstacle/Container'))
const LoginContainer = lazy(() => import('container/Login/Container'))
const LoginIngContainer = lazy(() => import('container/Login/Ing'))
const LoginRedirectContainer = lazy(() => import('container/Login/Redirect'))
const LoginNewEmailAuthContainer = lazy(() => import('container/Login/NewEmailAuth'))
const MyAccountContainer = lazy(() => import('container/MyAccount/Container'))
const MyAccountContextContainer = lazy(() => import('container/MyAccount/Context'))
const SurveyCreateContainer = lazy(() => import('container/Survey/Create/Container'))
const SurveyWorkspaceContainer = lazy(() => import('container/Survey/Workspace/Container'))
const SurveyCreateShareFrameContainer = lazy(() => import('container/Survey/Create/Share/Frame'))
const SurveyLiveGuardContainer = lazy(() => import('container/Survey/Live/Guard'))
const SurveyLiveKakaoBrowserContainer = lazy(() => import('container/Survey/Live/KakaoBrowser'))
const SurveyLiveSampleContainer = lazy(() => import('container/Survey/Live/Sample'))
const SurveyPreviewIpContainer = lazy(() => import('container/Survey/Preview/Ip'))
const SurveyPreviewFrameContainer = lazy(() => import('container/Survey/Preview/Frame'))
const SurveyAnalysisSummaryReportLangContainer = lazy(() => import('container/Survey/Create/NewAnalysis/Summary/ReportLang'))
const SurveyAnalysisSummaryPrintContainer = lazy(() => import('container/Survey/Create/NewAnalysis/Summary/Print'))
const PaymentContainer = lazy(() => import('container/Payment/Container'))
const PaysetmentPaysetContainer = lazy(() => import('container/Payment/Payset'))
const SurveyAnalysisContainer = lazy(() => import('container/Survey/Analysis/Container'))

const Page404 = lazy(() => import('component/Page404'))
const ApplicationGoogleSheetCalbackComponent = lazy(() => import('component/Application/GoogleSheet/Callback'))
const ApplicationSlackPushCalbackComponent = lazy(() => import('component/Application/SlackPush/Callback'))
const ErrorComponent = lazy(() => import('component/Error/Component'))

const TossCallComponent = lazy(() => import('component/Payment/Choice/api/TossCall'))
const TossSuccessComponent = lazy(() => import('component/Payment/Choice/api/TossSuccess'))
const TossCloseComponent = lazy(() => import('component/Payment/Choice/api/TossClose'))

const SLoginContainer = lazy(() => import('container/SLogin'))

const suspenseMsg = ``

const redirectTo = '/logining'

const App = () =>  {

    // 로그인은 HttpOnly 쿠키 세션. 앱 시작때 me 로 확인한 결과 (재로그인 대상이면 화면 대신 모달)
    // 로그인 여부만 구독한다. 정보가 바뀔때마다 다시 그리면 아래 라우트(component={props => ...})가 통째로 다시 마운트된다
    const hasMe = useSyncExternalStore(subscribeMe, getHasMe)
    const isAuth = hasMe || hasLoginContext()

    return (
        <>
        <Router>
            <Switch>
            {
                /*
                ** 장애 발생 시 사용자에에게 안내를 보여야할때 주석을 해제한다. 
                <Route path='/' component={props => <Suspense fallback={suspenseMsg}><ObstacleContainer {...props}/></Suspense>}/>         
                */
            }
            <Route exact path='/secrect001001301102/login' component={props => <Suspense fallback={suspenseMsg}><SLoginContainer {...props}/></Suspense>}/>            

            <Route exact path='/login' component={props => <Suspense fallback={suspenseMsg}><LoginContainer  {...props}/></Suspense>}/>
            <Route exact path='/logining' component={props => <Suspense fallback="Logining..."><LoginIngContainer  {...props}/></Suspense>}/>
            <Route exact path='/redirect' component={props => <Suspense fallback="Redirect..."><LoginRedirectContainer  {...props}/></Suspense>}/>
            <Route exact path='/(rs|r|c)/:args' component={props => <Suspense fallback={suspenseMsg}><SurveyLiveKakaoBrowserContainer root="ip" {...props}/></Suspense>}/>
            <Route exact path='/(ro|o)/:args' component={props => <Suspense fallback={suspenseMsg}><SurveyLiveKakaoBrowserContainer root="ip" {...props}/></Suspense>}/>
            <Route exact path='/(re|e)/:args' component={props => <Suspense fallback={suspenseMsg}><SurveyLiveKakaoBrowserContainer root="email" {...props}/></Suspense>}/>
            {/* 알림톡 배포 참여 링크가 /rk/:args/:share_token에서 /rk/:share_token으로 단순화됐다(요구사항75) — args는 더 이상 URL에 없다 */}
            <Route exact path='/rk/:share_token' component={props => <Suspense fallback={suspenseMsg}><SurveyLiveKakaoBrowserContainer root="alimtalk" {...props}/></Suspense>}/>

            <Route 
                exact 
                path='/sample/:args' 
                component={props => (
                    <Suspense fallback={suspenseMsg}>
                        <SurveyLiveSampleContainer>
                            <SurveyLiveGuardContainer root="ip" {...props}/>
                        </SurveyLiveSampleContainer>
                    </Suspense>
                )}
            />
            
            <Route exact path='/ts/:args' component={props => <Suspense fallback={suspenseMsg}><SurveyPreviewIpContainer {...props}/></Suspense>}/>

            <Route exact path='/(preport|p)/:analysisArgs' component={props => <Suspense fallback={suspenseMsg}><SurveyAnalysisSummaryReportLangContainer {...props}/></Suspense>}/>
            <Route exact path='/z/:analysisArgs/:id' component={props => <Suspense fallback={suspenseMsg}><SurveyAnalysisSummaryReportLangContainer personalSummary={true} {...props}/></Suspense>}/>
            <Route exact path='/new-email-auth/:no' component={props => <Suspense fallback="Logining..."><LoginNewEmailAuthContainer  {...props}/></Suspense>}/>
            
            <AuthRoute exact path='/' component={props => <AuthGate><Suspense fallback={suspenseMsg}><SurveyWorkspaceContainer {...props}/></Suspense></AuthGate>} redirectTo={redirectTo} authenticated={isAuth} />

            <AuthRoute path='/myaccount' exact component={props => <AuthGate><Suspense fallback={suspenseMsg}><MyAccountContainer {...props}/></Suspense></AuthGate>} redirectTo={redirectTo} authenticated={isAuth} />
            <AuthRoute path='/myaccount/frame' exact component={props => <AuthGate><Suspense fallback={suspenseMsg}><MyAccountContextContainer {...props}/></Suspense></AuthGate>} redirectTo={redirectTo} authenticated={isAuth} />
            
            <AuthRoute path='/myaccount' exact component={props => <AuthGate><Suspense fallback={suspenseMsg}><MyAccountContainer {...props}/></Suspense></AuthGate>} redirectTo={redirectTo} authenticated={isAuth} />

            <AuthRoute 
                path='/application/googlesheet/callback/:survey_no' 
                exact 
                component={props => <AuthGate><Suspense fallback={suspenseMsg}><ApplicationGoogleSheetCalbackComponent {...props}/></Suspense></AuthGate>} 
                redirectTo={redirectTo} 
                authenticated={isAuth} 
            />

            <AuthRoute 
                path='/application/slack/callback/:survey_no' 
                exact 
                component={props => <AuthGate><Suspense fallback={suspenseMsg}><ApplicationSlackPushCalbackComponent {...props}/></Suspense></AuthGate>} 
                redirectTo={redirectTo} 
                authenticated={isAuth} 
            />

            <AuthRoute 
                path='/error/:kind' 
                exact 
                component={props => <AuthGate><Suspense fallback={suspenseMsg}><ErrorComponent {...props}/></Suspense></AuthGate>} 
                redirectTo={redirectTo} 
                authenticated={isAuth} 
            />

            <AuthRoute path='/workspace' exact component={props => <AuthGate><Suspense fallback={suspenseMsg}><SurveyWorkspaceContainer {...props}/></Suspense></AuthGate>} redirectTo={redirectTo} authenticated={isAuth} />

            <AuthRoute path='/analysis/:survey_workspace_no/:survey_no' exact component={props => <AuthGate><Suspense fallback={suspenseMsg}><SurveyAnalysisContainer {...props}/></Suspense></AuthGate>} redirectTo={redirectTo} authenticated={isAuth} />

            <AuthRoute path='/survey/form/:step(create|share|analysis|connection)/:survey_no' exact component={props => <AuthGate><Suspense fallback={suspenseMsg}><SurveyCreateContainer {...props}/></Suspense></AuthGate>} redirectTo={redirectTo} authenticated={isAuth}/> 
            {/* 미리보기 모바일 보기 iframe (component/Survey/Preview/Shell) */}
            <AuthRoute path='/survey/preview/frame/:survey_no' exact component={props => <AuthGate><Suspense fallback={suspenseMsg}><SurveyPreviewFrameContainer {...props}/></Suspense></AuthGate>} redirectTo={redirectTo} authenticated={isAuth}/>
            <AuthRoute path='/survey/create/share/frame/:survey_no' exact component={props => <AuthGate><Suspense fallback={suspenseMsg}><SurveyCreateShareFrameContainer {...props}/></Suspense></AuthGate>} redirectTo={redirectTo} authenticated={isAuth}/>

            <AuthRoute path='/payment/call' exact component={props => <AuthGate><Suspense fallback={suspenseMsg}><TossCallComponent {...props}/></Suspense></AuthGate>} redirectTo={redirectTo} authenticated={isAuth}/>
            <AuthRoute path='/payment/success' exact component={props => <AuthGate><Suspense fallback={suspenseMsg}><TossSuccessComponent {...props}/></Suspense></AuthGate>} redirectTo={redirectTo} authenticated={isAuth}/>
            <AuthRoute path='/payment/close' exact component={props => <AuthGate><Suspense fallback={suspenseMsg}><TossCloseComponent {...props}/></Suspense></AuthGate>} redirectTo={redirectTo} authenticated={isAuth}/>

            <AuthRoute path='/payment/:step' exact component={props => <AuthGate><Suspense fallback={suspenseMsg}><PaymentContainer {...props}/></Suspense></AuthGate>} redirectTo={redirectTo} authenticated={isAuth}/>

            <AuthRoute path='/payset' exact component={props => <AuthGate><Suspense fallback={suspenseMsg}><PaysetmentPaysetContainer {...props}/></Suspense></AuthGate>} redirectTo={redirectTo} authenticated={isAuth}/>
            <AuthRoute 
                exact 
                path='/print/summary/:survey_no' 
                component={props => <AuthGate><Suspense fallback={suspenseMsg}><SurveyAnalysisSummaryPrintContainer {...props}/></Suspense></AuthGate>}  
                redirectTo={redirectTo} 
                authenticated={isAuth}
            />
            
            <Route exact path='/file/download' component={props => <Suspense fallback={suspenseMsg}><FileDownloadContainer {...props}/></Suspense>}/>
            <Route exact path='/myfile/download' component={props => <Suspense fallback={suspenseMsg}><MyResponseFileDowoloadLocaleContainer {...props}/></Suspense>}/>

            <Route component={props => <Suspense fallback={suspenseMsg}><Page404 {...props}/></Suspense>}/>
            </Switch>
        </Router>
        <Alert/>
        <AlertSnackbar/>
        <Confirm/>
        <Dialog/>
        <Loading/>
        <BackDrop/>
        <ErrorPage/>
        <AnswerErrorPage/>
        <Popover/>
        <IframeDialog/>
        <ModuleTipPopup/>
        <SessionGuard/>
        </>
    )
}

export default () => {
    const { lang } = useSelector(state => state.lang)
    const _ = useSelector(state => state.loginMount)

    useEffect(() => {
        TagManager.initialize({ gtmId: googleConfig.gtm })

        const domain = window.location.hostname;

        if (process.env.REACT_APP_ADMIN_DOMAIN !== domain) return
        
        const handleBeforeUnload = (e) => {
            // tawk 닫는 스크립트 호출
            if (window.Tawk_API && typeof window.Tawk_API.minimize === "function") {
              window.Tawk_API.minimize();
            }
        };
        
        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [])
   
    return (
        <LangComponent lang={lang}>
            <App/>
        </LangComponent>
    )
}